var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurgerMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 395.5 331.6",
    style: {
      enableBackground: "new 0 0 395.5 331.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000132796209294254473430000015260033960247755434_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    width: 395.5,
    height: 331.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001645199997492143540000004852733536083056562_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000001645199997492143540000004852733536083056562_)",
      fill: "#FFFFFF"
    },
    d: "M362.6,65.7H32.9 C14.7,65.7,0,51,0,32.9S14.7,0,32.9,0h329.8c18.2,0,32.9,14.7,32.9,32.9S380.8,65.7,362.6,65.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000001645199997492143540000004852733536083056562_)",
      fill: "#FFFFFF"
    },
    d: "M362.6,198.7H32.9 C14.7,198.7,0,184,0,165.8s14.7-32.9,32.9-32.9h329.8c18.2,0,32.9,14.7,32.9,32.9S380.8,198.7,362.6,198.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000001645199997492143540000004852733536083056562_)",
      fill: "#FFFFFF"
    },
    d: "M362.6,331.6H32.9 C14.7,331.6,0,316.9,0,298.7s14.7-32.9,32.9-32.9h329.8c18.2,0,32.9,14.7,32.9,32.9S380.8,331.6,362.6,331.6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger-menu.fb7b534d83e3581b2a3d0dfb41b43fe1.svg";
export { ForwardRef as ReactComponent };